import {
  Section,
  Skeleton,
  Text,
} from "@mittwald/flow-remote-react-components";

export const ImageCompressionSkeleton = () => {
  return (
    <Section>
      <Text>
        Reduziere die Dateigröße deiner Bilder automatisch durch
        WebP-Komprimierung, um die Ladegeschwindigkeit deiner Website deutlich
        zu verbessern. Die Umwandlung erfolgt direkt auf dem Server beim
        Ausliefern der Bilder – ganz ohne Plugin oder manuelle Optimierung.
      </Text>

      <Section>
        {/* RadioGroup Skeleton */}
        <Skeleton height="120px" width="100%" />

        {/* NumberField Skeleton (conditional) */}
        <Skeleton height="60px" width="50%" />

        {/* ActionGroup Skeleton (conditional) */}
        <Skeleton height="40px" width="200px" />
      </Section>
    </Section>
  );
};
